export default () => {
  return (
    <svg width="69" height="1487" viewBox="0 0 69 1487" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 1486.5V473L401.5 705V1486.5H0Z" fill="#FBEFFF"/>
      <rect x="0.866044" width="945.299" height="462.76"
            transform="matrix(0.866044 -0.499967 0.866044 0.499967 0.116012 473.551)" stroke="black"
            strokeDasharray="10 10"/>
    </svg>
  )
}